import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'url-search-params-polyfill';

import DemoWrapper from '../DemoWrapper';
import Search from './Search';

import SearchFormat from '../utils/searchFormat';
import UrlTool from '../utils/urlTool';
import isEqual from '../utils/compare';
import Storage from '../utils/storage';
import loop54Client from '../utils/loop54Client';
import handleResponseError from '../utils/responseError';

class SearchContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      searchTerm: '',
      selectedFacets: {},
      sortAttribute: 'relevance',
      sortDescending: 'false',
      results: null,
      directResults: [],
      relatedResults: [],
      fetchingResults: false,
      layout: {filters: 'top', related: 'bottom'}
    }
  }

  componentWillMount() {
    let newState = {};
    let query = new URLSearchParams(this.context.router.route.location.search);
    if(query.get('p')) {
      newState.page = parseInt(query.get('p'), 0)
    }

    let searchStorage = Storage.getSession(this.props.config.name + '-searchState');
    if(searchStorage && searchStorage.searchTerm === query.get('q')) {
      newState.selectedFacets = searchStorage.selectedFacets
      newState.sortAttribute = searchStorage.sortAttribute
      newState.sortDescending = searchStorage.sortDescending.toString()
    }

    let layoutStorage = localStorage.getItem(this.props.config.name + '-layout');
    if(layoutStorage) {
      newState.layout = JSON.parse(layoutStorage);
    }

    if(query.get('q') && (this.state.searchTerm !== query.get('q'))) {
      var searchObject = {value: query.get('q'), facet: query.get('f'), ...newState}
      this.handleSearch(searchObject)
    }

    this.setState(newState);
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    let query = new URLSearchParams(nextContext.router.route.location.search);
    let currentQuery = new URLSearchParams(this.context.router.route.location.search);

    if(currentQuery.get('f') && !query.get('f')) { return false; }

    if((query.get('q') && (nextState.searchTerm !== query.get('q'))) ||
      ((nextState.searchTerm === query.get('q')) && (this.state.page !== nextState.page)) ||
      (this.state.sortAttribute !== nextState.sortAttribute || this.state.sortDescending !== nextState.sortDescending))
    {

      // console.log("[1]", query.get('q'), nextState.searchTerm !== query.get('q'))
      // console.log("[2]", nextState.searchTerm === query.get('q'), (this.state.page !== nextState.page), this.state.page, nextState.page)
      // console.log("[3]", this.state.sortAttribute !== nextState.sortAttribute, this.state.sortDescending !== nextState.sortDescending)
      let facet = null;
      if(!isEqual(this.state.selectedFacets, nextState.selectedFacets) &&
        Object.keys(nextState.selectedFacets).length === 1 &&
        nextState.selectedFacets[this.props.config.autoCompleteFacetingParameter] &&
        nextState.selectedFacets[this.props.config.autoCompleteFacetingParameter].length === 1
      ) {
        facet = nextState.selectedFacets[this.props.config.autoCompleteFacetingParameter][0];
      } else if(query.get('f')) {
        facet = query.get('f');
      }

      if(query.get('q') && (nextState.searchTerm !== query.get('q')) && query.get('p') && query.get('p') !== 1) {
        UrlTool.replaceQuery('p', 1, nextContext.router, query)
      }
      let searchObject = {value: query.get('q'), facet: facet, page: nextState.page - 1, sortAttribute: nextState.sortAttribute, sortDescending: nextState.sortDescending }
      this.handleSearch(searchObject, null, query, nextState);
    }
  }

  handleSearch = (item, facets, parsedQuery, nextState, manualUpdate) => {
    let state = nextState ? nextState : this.state;
    if(!state.fetchingResults) {
      this.setState({
        fetchingResults: true
      })

      let selectedFacets = {};
      let sortAttribute, sortDescending = false;
      let query = parsedQuery ? parsedQuery : new URLSearchParams(this.context.router.route.location.search);
      let requestPage = typeof(item.page) !== 'undefined' ? item.page : query.get('p') ? parseInt(query.get('p'), 0) - 1 : 0;

      // if facet was present in the URL (i.e. it's a search from another page) this will trigger
      if(item.facet) {
        selectedFacets[this.props.config.autoCompleteFacetingParameter] = [item.facet];
        query.delete('f')
        this.context.router.history.replace({...this.context.router.history.location, search: query.toString()})
        this.handlePageChange(1);
        requestPage = 0;
      }

      // if facets are sent from facets component (i.e. a facet has been selected in a facet box or range facet has been dragged) this will trigger
      if(facets && Boolean(Object.keys(facets).length)) {
        selectedFacets = facets;
        this.handlePageChange(1);
        requestPage = 0;
      }


      // if a query is present in the URL and that query isn't matching the one sent with the handleSearch call, we will update the URL with the new one
      if(query.get('q') && (item.value !== query.get('q'))) {
        UrlTool.setQuery('q', item.value, this.context.router, query);
        this.handlePageChange(1);
        requestPage = 0;
      // if it's the same query but selectedFacets are present, we want to add them to the request (i.e. if you use pagination)
      } else if(!query.get('q')) {
        UrlTool.setQuery('q', item.value, this.context.router, query);
        requestPage = 0;
      } else if(!manualUpdate && !Boolean(Object.keys(selectedFacets).length) && Boolean(Object.keys(state.selectedFacets).length)) {
        selectedFacets = this.state.selectedFacets;
      }

      if(item.sortAttribute) {
        if(item.sortAttribute !== 'relevance') {
          sortAttribute = item.sortAttribute;
          sortDescending = item.sortDescending;
        }
      } else if(this.state.sortAttribute !== 'relevance') {
        sortAttribute = this.state.sortAttribute;
        sortDescending = this.state.sortDescending;
      }

      // MANUAL PARAMS PRESENT
      if(typeof(item.requestPage) !== 'undefined') {
        requestPage = item.requestPage;
      }

      if(item.selectedFacets) {
        selectedFacets = item.selectedFacets;
      }

      if(item.sortAttribute) {
        sortAttribute = item.sortAttribute;
        sortDescending = item.sortDescending;
      }

      let sessionObject = {
        searchTerm: item.value,
        selectedFacets: selectedFacets,
        sortAttribute: sortAttribute ? sortAttribute : this.state.sortAttribute,
        sortDescending: sortDescending
      }

      Storage.setSession(this.props.config.name + '-searchState', sessionObject);

      let req = SearchFormat.request(item, selectedFacets, { config: this.props.config, page: requestPage, sortAttribute: sortAttribute, sortDescending: Boolean(sortDescending) });

      this.setState({ searchTerm: item.value, selectedFacets: selectedFacets })

      loop54Client.search(item.value, req).then(response => {
        let parsedResponse = SearchFormat.response(response);

        //If diagnostic user exist on the reponse we set in the the demowrapper state and pass it down to the diagnostic toolbar.
        parsedResponse.customData && parsedResponse.customData["Diagnostics.User"] && this.props.onSetDiagnosticUser(parsedResponse.customData["Diagnostics.User"]);

        this.setState({
          fetchingResults: false,
          results: parsedResponse,
          directResults: parsedResponse.results.items,
          relatedResults: parsedResponse.relatedResults.items,
        })
      })
      .catch(response => handleResponseError(response));
    }
  }

  handlePageChange = (page) => {
    let query = new URLSearchParams(this.context.router.route.location.search);
    this.setState({
      page: page
    })
    if(query.get('p') && page > 1) {
      UrlTool.setQuery('p', page, this.context.router);
    }
  }

  handleShowMore = (page) => {
    this.setState({
      page: page
    })
    UrlTool.setQuery('p', page, this.context.router);
  }

  handleSortChange = (e, data) => {
    let sort = data.value.split('>')
    if(sort.length > 1 && sort[1] === 'DESC') {
      this.setState({
        sortAttribute: sort[0],
        sortDescending: true
      })
    } else {
      this.setState({
        sortAttribute: sort[0],
        sortDescending: false
      })
    }
  }

  handleSelectedFacetsChange = (selectedFacets) => {
    UrlTool.setQuery('q', this.state.searchTerm, this.context.router)
    this.handleSearch({ value: this.state.searchTerm }, selectedFacets, null, null, true)
  }

  handleSearchFieldChange = (selectedItem) => {
    let facet = null;
    if(selectedItem.facet) {
      facet = {};
      UrlTool.replaceQuery('p', 1, this.context.router);
      facet[this.props.config.autoCompleteFacetingParameter] = [selectedItem.facet];
    }
    if(selectedItem.value === this.state.searchTerm) {
      UrlTool.replaceQuery('p', 1, this.context.router);
      this.setState({
        page: 1,
      }, this.handleSearch({value: selectedItem.value, requestPage: 0}, facet, null, null, true))
    } else if(selectedItem.facet) {
      this.setState({
        selectedFacets: facet
      }, UrlTool.setQuery('q', selectedItem.value, this.context.router))
    } else {
      this.setState({
        page: 1,
        selectedFacets: {}
      }, UrlTool.setQuery('q', selectedItem.value, this.context.router))
    }
  }

  handleReset = () => {
    this.props.onReset();
    UrlTool.replaceQuery('p', 1, this.context.router);
    this.setState({
      page: 1,
      selectedFacets: {},
      sortAttribute: 'relevance',
      sortDescending: 'false'
    }, this.handleSearch({value: this.state.searchTerm, requestPage: 0}, null, null, null, true))
  }

  handleChangeLayout = (layout) => {
    let newLayout = {};

    switch(layout) {
      case 'TLR':
        newLayout = {filters: 'top', related: 'right'}
        break;
      case 'TMB':
        newLayout = {filters: 'top', related: 'bottom'}
        break;
      case 'LRB':
        newLayout = {filters: 'left', related: 'bottom'}
        break;
      case 'LMR':
        newLayout = {filters: 'left', related: 'right'}
        break;
      default:
        break;
    }

    this.setState({
      layout: newLayout
    }, localStorage.setItem(this.props.config.name + '-layout', JSON.stringify(newLayout)))
  }

  render() {
    return (
      <Search
        {...this.state}
        {...this.props}
        search={this.handleSearch}
        onSelectedFacetsChange={this.handleSelectedFacetsChange}
        onSearchFieldChange={this.handleSearchFieldChange}
        onPageChange={this.handlePageChange}
        onShowMore={this.handleShowMore}
        onSortChange={this.handleSortChange}
        onBasketChange={this.props.onBasketChange}
        onReset={this.handleReset}
        onChangeDesign={this.props.onChangeDesign}
        onChangeLayout={this.handleChangeLayout}
      />
    );
  }
}

SearchContainer.contextTypes = {
  router: PropTypes.object
}

export default DemoWrapper(SearchContainer);
